import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase/firebaseConfig";
import { doc, getDoc, deleteDoc, updateDoc } from "firebase/firestore";
import "../styles/posts.css";

function Posts() {
  const [posts, setPosts] = useState([]);
  const [user, loading, error] = useAuthState(auth);
  const [username, setUsername] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const handleAccept = async (postId) => {
    try {
      const postDocRef = doc(db, "posts", postId);

      await updateDoc(
        postDocRef,
        {
          acceptedBy: username, // Or whatever identifier you want to use
        },
        { merge: true }
      ); // Add the 'merge' option

      console.log("Post accepted!");
    } catch (error) {
      console.error("Error accepting post: ", error);
    }
  };

  useEffect(() => {
    const postsRef = collection(db, "posts");
    const q = query(postsRef, orderBy("timestamp", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const postsArray = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPosts(postsArray);
    });

    return () => unsubscribe(); // Detach listener on unmount
  }, []);

  useEffect(() => {
    const fetchUsername = async () => {
      if (user) {
        // Check if the user is actually logged in
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          setUsername(userDoc.data().username);
        } // handle if doc doesn't exist
      }
    };
    fetchUsername();
  }, [user]);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user) {
        // Check if the user is actually logged in
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          setUsername(userDoc.data().username);
          setUserRole(userDoc.data().role); // Add this line
        } // handle if doc doesn't exist
      }
    };
    fetchUserRole();
  }, [user]);

  const handleDelete = async (postId) => {
    try {
      const postDocRef = doc(db, "posts", postId);
      await deleteDoc(postDocRef);
      console.log("Post successfully deleted");
    } catch (error) {
      console.error("Error deleting post: ", error);
    }
  };

  const handleCompleteWasher = async (postId) => {
    const postDocRef = doc(db, "posts", postId);

    try {
      await updateDoc(postDocRef, { completeWasher: true });
      await checkCompletion(postId);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCompleteWearer = async (postId) => {
    const postDocRef = doc(db, "posts", postId);

    try {
      await updateDoc(postDocRef, { completeWearer: true });
      await checkCompletion(postId);
    } catch (error) {
      console.log(error);
    }
  };

  const checkCompletion = async (postId) => {
    const postDocRef = doc(db, "posts", postId);
    const docSnapshot = await getDoc(postDocRef); // Fetch the document data

    if (docSnapshot.exists()) {
      const postData = docSnapshot.data(); // Extract the data from the document
      if (postData.completeWasher === true) {
        console.log("Washer complete");

        if (postData.completeWearer === true) {
          console.log("Wearer complete");
          handleDelete(postId);
        }
      }
    } else {
      console.log("No such document!");
    }
  };

  return (
    <div className="siteWrapper">
      <div className="post-container">
      <div className="posts-wrapper">
        <div className="post-feed-header">
          <h2>Community Feed</h2>
          {userRole === "wearer" && (
            <Link to="/new-post" className="create-new-button">
              Create New Post
            </Link>
          )}
        </div>
        {posts.map((post) => (
          <div
            key={post.id}
            className={`post-card ${post.acceptedBy ? "post-accepted" : ""}`}
          >
            <div className="post-card-header">
            <div className="user-icon">{post.name.charAt(0)}</div>
              <div className="post-name-location">
              
                <h3>
                  {post.name}&nbsp;-&nbsp;
                  <span className="post-dorm-span">
                    {post.dorm}, {post.roomNumber}
                  </span>
                  
                </h3>
                <span className="date-time">
                {new Date(post.timestamp.seconds * 1000).toLocaleString()}
              </span>
              </div>
              
            </div>
            
            <div className="post-card-content">
              <p>{post.description}</p>
            </div>
            <div className="post-card-actions">
              {userRole === "washer" &&
                !post.acceptedBy && ( // Use userRole state
                  <button onClick={() => handleAccept(post.id)}>Accept</button>
                )}

              {post.acceptedBy && (
                <span className="accepted-status">
                  Accepted by {post.acceptedBy}
                </span>
              )}

              {(post.name === username || post.acceptedBy === username) && ( // Check against the creator
                <Link to={`/posts/${post.id}`} className="comment-link">
                  View Comments
                </Link>
              )}

              {post.name === username && ( // Check against the creator
                <span
                  className="delete-word"
                  onClick={() => handleDelete(post.id)}
                >
                  Delete
                </span>
              )}

              {post.acceptedBy === username && ( // Check against the creator
                <button
                  style={{
                    backgroundColor: post.completeWasher ? "green" : "red",
                  }}
                  className="completeWashBtn"
                  onClick={() => handleCompleteWasher(post.id)}
                >
                  {post.completeWasher ? "Waiting for Wearer" : "Complete Wash"}
                </button>
              )}

              {post.name === username && ( // Check against the creator
                <button
                  style={{
                    backgroundColor: post.completeWearer ? "green" : "red",
                  }}
                  className="completeWashBtn"
                  onClick={() => handleCompleteWearer(post.id)}
                >
                  {post.completeWearer
                    ? "Waiting for Washer"
                    : "Completed Wash?"}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
}

export default Posts;
